import { render } from "./BaseTextElement.vue?vue&type=template&id=2516077d&scoped=true&ts=true"
import script from "./BaseTextElement.vue?vue&type=script&lang=ts"
export * from "./BaseTextElement.vue?vue&type=script&lang=ts"

import "./BaseTextElement.vue?vue&type=style&index=0&id=2516077d&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2516077d"]])

export default __exports__